import React from "react";
import { Link } from "react-router-dom";

export default function PageHeader(props) {
  return (
      <div id="printPageButton" className="d-md-flex d-block align-items-center justify-content-between mb-3">
        <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
          <div  id="printPageButton" className="my-auto mb-2">
            <h3 className="page-title mb-1">{props.title}</h3>
            <nav>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <Link to="/">Dashboard</Link>
                </li>
                {props.items &&
                    props.items.length > 0 &&
                    props.items.map((item, index) => {
                      return (
                          <li key={index} className="breadcrumb-item active" aria-current="page">{item}</li>
                      );
                    })}
              </ol>
            </nav>
          </div>
        </div>
      </div>
  );
}
